import * as React from "react";
const NoProviderSvg = (props) => (
  <svg
    width={159}
    height={158}
    viewBox="0 0 159 158"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={1} y={0.5} width={157} height={157} rx={78.5} fill="url(#a)" />
    <rect x={1} y={0.5} width={157} height={157} rx={78.5} stroke="url(#b)" />
    <g clipPath="url(#c)">
      <path
        d="M72.208 51.292A7.29 7.29 0 0 1 79.5 44a7.29 7.29 0 0 1 7.292 7.292 7.29 7.29 0 0 1-7.292 7.291 7.29 7.29 0 0 1-7.292-7.291m33.542 1.458c-4.824 0-8.75 3.926-8.75 8.75v15.08a8.75 8.75 0 0 0-8.765 1.762L79.5 86.378l-8.765-8.064A8.76 8.76 0 0 0 62 76.579V61.5c0-4.824-3.926-8.75-8.75-8.75s-8.75 3.926-8.75 8.75v35.674a8.75 8.75 0 0 0 2.252 5.862L56.642 114h7.855L51.083 99.13a2.93 2.93 0 0 1-.753-1.956V61.5a2.92 2.92 0 0 1 2.917-2.917 2.92 2.92 0 0 1 2.917 2.917v23.333h.032a9.02 9.02 0 0 0 2.144 5.755l7.63 7.936 4.203-4.045-7.5-7.788a2.92 2.92 0 0 1 .065-3.806 2.9 2.9 0 0 1 2.004-.963 2.84 2.84 0 0 1 2.07.712L78.556 93.44a2.92 2.92 0 0 1 .94 2.147v18.416h5.832V95.587c0-1.85-.592-3.643-1.656-5.122l8.479-7.802a2.85 2.85 0 0 1 2.1-.738c.775.044 1.52.36 2.003.963.782.977.744 1.948.744 1.948h.012c.011.636-.178 1.252-.56 1.71l-7.388 7.682 4.203 4.045 7.519-7.83a8.7 8.7 0 0 0 2.03-5.607h.014V61.5a2.92 2.92 0 0 1 2.917-2.917 2.92 2.92 0 0 1 2.917 2.917v35.674c0 .723-.268 1.417-.753 1.957L94.495 114h7.854l9.891-10.964a8.75 8.75 0 0 0 2.251-5.862V61.5c0-4.824-3.926-8.75-8.75-8.75zM73.667 68.792a1.46 1.46 0 0 1 1.458-1.459h8.75a1.46 1.46 0 0 1 1.458 1.459v4.398a14.9 14.9 0 0 1 5.834-2.634V68.79c0-4.02-3.27-7.292-7.292-7.292h-8.75c-4.022 0-7.292 3.273-7.292 7.292v1.758a14.4 14.4 0 0 1 5.834 2.631z"
        fill="#000"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={79.5}
        y1={0}
        x2={79.5}
        y2={128.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={79.5}
        y1={0}
        x2={79.5}
        y2={158}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D4D4D4" />
        <stop offset={0.825} stopColor="#F8F4F4" stopOpacity={0} />
      </linearGradient>
      <clipPath id="c">
        <path fill="#fff" d="M44.5 44h70v70h-70z" />
      </clipPath>
    </defs>
  </svg>
);
export default NoProviderSvg;
